export const Marquee = () => {
    const words = [
        "ŠIALENÉ",
        "DOMÁCE",
        "MALÁ SÉRIA",
        "KULTOVÝ FAVORIT",
        "SUROVÉ",
        "JEDEN NÁPOJ",
        "BEZ VÝHOVORIEK",
        "ČISTÉ MAD",
    ];

    return (
        <section
            data-testid="marquee-section"
            className="relative border-y border-white/10 bg-black overflow-hidden"
        >
            <div className="flex whitespace-nowrap animate-marquee py-6">
                {[...words, ...words, ...words].map((w, i) => (
                    <div
                        key={i}
                        className="font-display text-4xl sm:text-6xl uppercase tracking-tighter px-8 flex items-center gap-8"
                    >
                        <span
                            className={
                                i % 3 === 1
                                    ? "text-[#D91C1C]"
                                    : "text-white/90"
                            }
                        >
                            {w}
                        </span>
                        <span className="text-white/20">✕</span>
                    </div>
                ))}
            </div>
        </section>
    );
};
